import type { StylePropertiesTypes } from '@wix/document-services-types'
import {
	getStringFromConverter,
	getLengthString,
	getKeywordString,
	getConverterString,
} from '../../utils/converterHelpers'

/** Internal Converters */
const baseShadowConverter = (shadowProp: StylePropertiesTypes.BoxShadowItem | StylePropertiesTypes.Shadow) => {
	const { offsetX: offsetXProp, offsetY: offsetYProp, blurRadius: blurRadiusProp, color: colorProp } = shadowProp

	const offsetX = offsetXProp && getStringFromConverter(getLengthString(offsetXProp))
	const offsetY = offsetYProp && getStringFromConverter(getLengthString(offsetYProp))
	const blurRadius = blurRadiusProp && getStringFromConverter(getLengthString(blurRadiusProp))

	// Handle color with dynamic type
	const color = colorProp && getConverterString(colorProp.type, colorProp)

	return {
		offsetX,
		offsetY,
		blurRadius,
		color,
	}
}

const boxShadowConverter = (shadowProp: StylePropertiesTypes.BoxShadowItem) => {
	const baseShadow = baseShadowConverter(shadowProp)

	const { spreadRadius: spreadRadiusProp, position: positionProp } = shadowProp
	const spreadRadius = spreadRadiusProp ? getStringFromConverter(getLengthString(spreadRadiusProp)) : ''
	const position = positionProp ? getStringFromConverter(getKeywordString(positionProp)) : ''

	// Fix order: position should come before color
	const values = [
		baseShadow.offsetX,
		baseShadow.offsetY,
		baseShadow.blurRadius,
		spreadRadius,
		position,
		baseShadow.color,
	]
		.filter(Boolean)
		.join(' ')

	// Return string directly instead of object
	return values
}

const shadowConverter = (shadowProp: StylePropertiesTypes.Shadow) => {
	const baseShadow = baseShadowConverter(shadowProp)

	const values = [baseShadow.offsetX, baseShadow.offsetY, baseShadow.blurRadius, baseShadow.color]
		.filter(Boolean)
		.join(' ')

	// Return string directly instead of object
	return values
}

/** External Map */
export const shadowConverterMap = {
	BoxShadow: boxShadowConverter,
	Shadow: shadowConverter,
}
